// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__FV7sm","tyre":"style_tyre__5P2Jx"};